'use strict';

var pull = require('pull-stream');

var toPull = require('stream-to-pull-stream');

var deferred = require('pull-defer');

var moduleConfig = require('../utils/module-config');

var _require = require('./refs'),
    checkArgs = _require.checkArgs,
    normalizeOpts = _require.normalizeOpts;

module.exports = function (send) {
  send = moduleConfig(send);
  return function (args, opts) {
    opts = normalizeOpts(opts);
    var p = deferred.source();

    try {
      args = checkArgs(args);
    } catch (err) {
      return p.end(err);
    }

    send({
      path: 'refs',
      args: args,
      qs: opts
    }, function (err, stream) {
      if (err) {
        return p.resolve(pull.error(err));
      }

      p.resolve(pull(toPull.source(stream), pull.map(function (r) {
        return {
          ref: r.Ref,
          err: r.Err
        };
      })));
    });
    return p;
  };
};